// import commonEn from './common/en'

export default {
  errorMsg: '错误信息',
  confirm: '确定',
  save: '保存',
  cancel: '取消',
  copyright: '版权所有© 2013-2026 上海沃行信息技术有限公司',
  forTheRecord: '沪ICP备14001465号',
  trackingNo: '跟踪号',
  consignmentId: '母单号',
  track: '跟踪',
  success: '成功',
  message: {
    inputRequired: '请输入',
    selectRequired: '请选择',
    userEmailRequired: '请输入用户邮箱',
    userEmailFormat: '邮箱格式错误',
    retrieveTips: '确认后将发送邮件到邮箱进行密码重置',
    passwordFormat: '密码必须 6-20 位, 包含数字，大写字母和小写字母',
    passwordNotMatch: '确认密码需与输入的新密码保持一致',
    passwordExpired: '您的密码已过期，请联系管理员重置后再登录',
    ipNotAllowed: '您的IP地址 {ip} 不在允许访问范围内，登录被拒绝',
    oauthUserNotMatched: '未找到与该账号匹配的 eTower 用户，请联系管理员',
    oauthServiceUnavailable: '身份认证服务暂时不可用，请稍后重试',
    superAdminOnly: '仅超管账户可以登录',
    deviceNotRegistered: '当前浏览器或设备未注册，登录被拒绝。如需在新浏览器登录，请联系IT',
    passwordChangeSuccess: '密码修改成功',
    passwordChangeFailed: '密码修改失败',
    passwordResetSuccess: '密码已重置，新密码已发送至用户注册邮箱',
    passwordResetFailed: '密码重置失败，请稍后重试或联系系统管理员',
    passwordResetConfirm: '确定要重置该用户的密码吗？系统将按密码策略生成新密码并发送至其注册邮箱。',
    sendEmailFailed: '邮件发送失败，请稍后重试'
  },
  login: {
    hello: '您好！',
    welcomeToSignIn: '欢迎登录',
    emailAccount: '账号',
    password: '密码',
    signIn: '登录',
    signInWithMicrosoft: '使用 Microsoft 账号登录',
    thirdPartyLogin: '第三方登录',
    forgotPassword: '忘记密码？',
    chooseAnAccount: '请选择账户',
    retrievePassword: '找回密码',
    sendEmail: '发送邮件',
    back: '返回',
    backToLoginPage: '返回登录',
    resetPassword: '重置密码',
    setPassword: '设置密码',
    currentPassword: '原密码',
    logout: '退出登录'
  },
  common: {
    login: '登录',
    loading: '请求中...',
    sessionTimeout: '您的会话超时，请重新登录！',
    warning: '提示',
    backToLogin: '返回登录',
    details: '详情',
    copy: '复制',
    translate: '翻译',
    info: '消息',
    copySuccess: '复制成功',
    copyFailed: '复制错误',
    error: '错误',
    pleaseSelectLanguage: '请选择目标语言',
    userEmail: '用户邮箱',
    login2: '登录',
    placeholder: '每行输入一个单号，最多只允许提交30个单号。'
  },
  spww: {
    home: '主页',
    placeholder: '每行输入一个单号，最多只允许提交30个单号。',
    contactUs: '联系我们: atcecommercesese@gruposese.com',
    noEventFound: '暂时没有状态',
    languageSelect: '请选择目标语言',
    trackingNo: '跟踪号',
    forFurtherInformation: '更多信息'
  },
  ubi: {
    home: '主页',
    logOut: '退出',
    topTipsTitle: '利通智能包裹轨迹查询平台',
    topTipsContent: '全链路跨境物流整合商 B2C | B2B2C | B2B',
    contactUs: '联系我们： 400-017-6662 ubics-dlc@gotoubi.com'
  },
  nodes: {
    inf: '交运',
    rcv: '入库',
    scn: '出库',
    lhl: '计划交航',
    scnDes: '目的地扫描',
    dld: '妥投'
  },
  navbar: {
    logOut: '退出',
    loginIn: '登录',
    changePassword: '修改密码',
    newPassword: '新密码',
    confirmpassword: '确认密码',
    passwordLabelWidth: '80px'
  }
}
